import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { SERVER_REQUEST } from '@core/const';
import { WindowRef } from '@spartacus/core';
import { BREAKPOINT } from '@spartacus/storefront';
import { Request } from 'express';
import { map, Observable } from 'rxjs';
import { BrowserName, UserAgent } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class UserAgentService {
  private _userAgent: UserAgent;

  constructor(
    @Inject(PLATFORM_ID) private platform: any,
    @Optional() @Inject(SERVER_REQUEST) private request: Request | null,
    private winRef: WindowRef,
  ) {
    this._userAgent = new UserAgent(
      isPlatformServer(this.platform) ? this.userAgentFromReq : this.userAgentFromBrowser,
    );
  }

  get userAgent(): string {
    return this._userAgent.value;
  }

  get isBot(): boolean {
    return this._userAgent.isBot;
  }

  /**
   * Возвращает true, если это бот на ssr или браузер.
   *
   * Нужно чтобы снизить нагрузку с ssr, для пользователей
   * то, что можно грузить на клиенте, а для ботов на ssr
   */
  get isSsrBotOrBrowser(): boolean {
    return (isPlatformServer(this.platform) && this.isBot) || isPlatformBrowser(this.platform);
  }

  get browserName(): BrowserName | null {
    return this._userAgent.browserName;
  }

  get breakpoint$(): Observable<BREAKPOINT> {
    return this._userAgent.breakpoint$;
  }

  get os$(): Observable<string> {
    return this._userAgent.os$;
  }

  private get userAgentFromReq(): string {
    return this.request?.headers?.['user-agent'] || '';
  }

  private get userAgentFromBrowser(): string {
    if (this.winRef.isBrowser() && this.winRef.nativeWindow) {
      return this.winRef.nativeWindow.navigator.userAgent;
    }

    return '';
  }

  isIosApp(): boolean {
    if (this.winRef.isBrowser()) {
      const getString = this.winRef.location.search ?? '';

      return getString.includes('sdvor_main=app_ios');
    }

    return false;
  }

  isIOS(): Observable<boolean> {
    return this._userAgent.os$.pipe(map((os) => os === 'iOS'));
  }
}
